import {createReducer, on} from '@ngrx/store';
import * as catalogActions from './catalog.actions';

export const catalogFeatureKey = 'catalog';

export interface CatalogState {
  catalogIds: string[];
  loading: boolean;
}

export const catalogInitialState: CatalogState = {
  catalogIds: [],
  loading: false,
};

export const catalogReducer = createReducer(
  catalogInitialState,

  on(catalogActions.loadQualifyingCatalogIds, state => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(catalogActions.loadQualifyingCatalogIdsSuccess, (state, {catalogIds}) => {
    return {
      ...state,
      catalogIds: [...catalogIds],
      loading: false,
    };
  }),
  on(catalogActions.removeCatalogId, (state, {catalogId}) => {
    return {
      ...state,
      catalogIds: state.catalogIds.filter(id => id !== catalogId),
    };
  }),
  on(catalogActions.loadCatalogsFailure, state => {
    return {
      ...state,
      catalogIds: [],
      loading: false,
    };
  }),
);

export const getCatalogIds = (state: CatalogState | undefined): string[] =>
  state?.catalogIds ?? [];
export const getLoading = (state: CatalogState | undefined): boolean =>
  state?.loading ?? false;
